export default {
    "banner": {
        "header": "M2PAY SPREJEMANJE KARTIC",
        "motto": "POS naprave. Spletno. Mobilno. Kripto.",
        "learn-more-button": "Pošljite povpraševanje",
        "contact-us-button": "Kontaktirajte nas"
    },
    "reference": {
        "header": "Reference",
        "introduction": "Naše zadovoljne stranke"
    },
    "about-us": {
        "header": "O nas",
        "paragraph": {
            "line-1": "POS naprave. Spletno. Mobilno. Kripto.",
            "line-2": "Možnost sprejemanja in obračunavanja naročil prek ene POS naprave, ki uporablja aplikacijo za Android.",
            "line-3": "Po hitri namestitvi je POS naprava pripravljena za sprejemanje debetnih in kreditnih kartic na prodajnem mestu ali na terenu.",
            "line-4": "Naša POS naprava se lahko uporablja samostojno, poveže z vašo blagajno ali mobilno napravo prek brezplačne aplikacije M2PAY.",
            "line-5": "Naša rešitev je preprosta in pregledna glede stroškov."
        }
    },
    "devices": {
        "header": "M2Pay mPOS Naprava",
        "introduction": "POS naprave. Spletno. Mobilno. Kripto.",
        "PAX-A35": {
            "line-1": "Zasnovan za maloprodajo, trgovine in samopostrežne kioske, ki potrebujejo hitro, zanesljivo in kompaktno napravo.",
            "line-2": "Namenjen širokemu spektru poslovanja, vključno z:",
            "list": {
                "item-1": "Supermarketi: Hitra in učinkovita obdelava transakcij za velike količine strank.",
                "item-2": "Gostinstvo: Idealna rešitev za restavracije, kavarne in bare, ki potrebujejo hitro obračunavanje in integracijo z blagajno.",
                "item-3": "Samopostrežni kioski: Omogoča preprosto in varno samostojno nakupovanje, zmanjšuje gnečo in izboljšuje uporabniško izkušnjo."
            },
            "line-3": "POS terminal zagotavlja visoko zanesljivost in varnost plačil, s čimer izboljšuje produktivnost in zadovoljstvo strank."
        },
        "PAX-A920Pro": {
            "line-1": "Popolnoma mobilna POS naprava (4G, WiFi in Bluetooth) z dolgo življenjsko dobo baterije zagotavlja neprekinjeno delovanje skozi cel delovni dan.",
            "list": {
                "item-1": "Gostinstvo: Idealno za restavracije, kavarne in bare, omogoča preprosto upravljanje naročil in plačil neposredno za mizo.",
                "item-2": "Trgovina: Hitro in preprosto obračunavanje.",
                "item-3": "Možnost sprejemanja in obračunavanja naročil prek ene POS naprave, ki uporablja aplikacijo za Android.",
                "item-4": "Po hitri namestitvi je POS naprava pripravljena za sprejemanje debetnih in kreditnih kartic na prodajnem mestu ali na terenu.",
                "item-5": "Naša POS naprava se lahko uporablja samostojno, poveže z vašo blagajno ali mobilno napravo prek brezplačne aplikacije M2PAY.",
                "item-6": "Naša rešitev je preprosta in pregledna glede stroškov.",
                "item-7": "Idealna rešitev za majhne trgovce, kjer je potrebno vse v enem: blagajna, fiskalizacija, sprejemanje kartičnih plačil."
            },
            "line-2": "PAX A920 Pro je zaradi svojih kompaktnih dimenzij, dolgotrajne baterije in enostavne uporabe idealna rešitev za poslovne subjekte, ki iščejo zanesljivo, hitro in vsestransko POS napravo."
        },
        "PAX-A77": {
            "line-1": "MiniPOS – pametni POS terminal, namenjen restavracijam, kavarnam, klubom in drugim prodajnim mestom, kjer je potrebna mobilnost.",
            "list": {
                "item-1": "Ponuja preprosto nadgradnjo obstoječih aplikacij za sprejemanje brezgotovinskih plačil.",
                "item-2": "Omogoča pošiljanje naročil na blagajno in obračunavanje le-teh, vse prek ene naprave, kar močno olajša poslovanje.",
                "item-3": "Dolgotrajna avtonomija pomeni več delovnih ur med polnjenji.",
                "item-4": "Po hitri namestitvi je POS naprava pripravljena za sprejemanje debetnih in kreditnih kartic na prodajnem mestu ali na terenu."
            }
        },
        "PAX-A80": {
            "line-1": "PAX A80 je vsestranski POS terminal, ki lahko deluje kot fiksna naprava na pultu ali kot prenosni terminal za plačila zahvaljujoč opcijski bateriji.",
            "list": {
                "item-1": "Namenjen supermarketom, lekarnam in trgovinam: Hitra in učinkovita obdelava transakcij za velike količine strank.",
                "item-2": "Gostinstvo: Idealna rešitev za restavracije, kavarne in bare, ki potrebujejo hitro obračunavanje in integracijo z lastno blagajno.",
                "item-3": "Po hitri namestitvi je POS naprava pripravljena za sprejemanje debetnih in kreditnih kartic na prodajnem mestu ali na terenu."
            },
            "line-2": "Robustna in zanesljiva naprava A80 je idealna za poslovanja, ki potrebujejo stabilno in učinkovito rešitev za obračunavanje."
        },
        "PAX-A960": {
            "line-1": "Najmočnejša POS naprava iz serije A, izjemno lahka z veliko avtonomijo ter možnostjo tiskanja računov na licu mesta.",
            "list": {
                "item-1": "Možnost obračunavanja, izdaje računov ter pošiljanja naročil na blagajno, vse v eni napravi.",
                "item-2": "Idealno za gostinstvo ter prodajna mesta, kjer je potrebna mobilnost.",
                "item-3": "Po hitri namestitvi je POS naprava pripravljena za sprejemanje debetnih in kreditnih kartic na prodajnem mestu ali na terenu.",
                "item-4": "Idealna rešitev za majhne trgovce, kjer je potrebno vse v enem: blagajna, fiskalizacija, sprejemanje kartičnih plačil."
            }
        },
        "PAX-IM25": {
            "line-1": "Samostojna POS naprava, namenjena uporabi v vseh okoljih in vremenskih razmerah, kar jo naredi idealno za mesta, kjer je potrebno samostojno obračunavanje, kot so:",
            "list": {
                "item-1": "Parkirišča: Varna in hitra plačila za parkiranje.",
                "item-2": "Bencinske črpalke: Samostojno plačilo goriva in storitev.",
                "item-3": "Polnilnice za električna vozila: Brezkontaktno in preprosto plačilo električne energije.",
                "item-4": "Prodajni avtomati: Plačilo na avtomatih za hrano in pijačo.",
                "item-5": "Avtopralnice: Plačilo storitev neposredno na samopostrežnih avtopralnicah."
            },
            "line-2": "PAX IM25 je odporen na vlago, umazanijo in praske."
        }
    },
    "treasury": {
        "header": "POS blagajna",
        "introduction": "Blagajna z integriranim plačevanjem s karticami.",
        "flavour-text": {
            "line-1": "Paket, ki rešuje celotno poslovanje in plačevanje za majhne in srednje trgovce po ugodnih cenah!",
            "line-2": "Fiskalna blagajna, integrirana s plačevanjem s karticami M2Pay, omogoča mikro in malim podjetnikom sprejemanje plačil s karticami z nizkimi provizijami."
        },
        "checkmark-list": {
            "item-1": "Ena POS naprava kot blagajna, fiskalizacija in sprejemanje kartic z ugodnimi provizijami",
            "item-2": "Izplačilo na vaš IBAN naslednji delovni dan",
            "item-3": "Nakup ali mesečni najem blagajne",
            "item-4": "Podpora pri namestitvi in nadaljnjem delovanju"
        },
        "diamond-blocks": {
            "block-1": {
                "message-1": "Plačevanje s karticami, integrirano z blagajno",
                "message-2": "Model nakupa ali najema",
                "message-3": "Namestitev, podpora strankam, usposabljanje",
                "message-4": "Brezplačne nadgradnje aplikacije"
            },
            "block-2": {
                "message-1": "Spremljanje zakonodajnih sprememb",
                "message-2": "Sprejemanje kartic Maestro, Mastercard, Visa, Diners, Union Pay in JCB z ugodnimi provizijami",
                "message-3": "Brez odpiranja novega bančnega računa – sredstva se nakažejo na vaš obstoječi račun",
                "message-4": "Delovanje brez povezave – možnost izdaje računov v primeru izgube internetne povezave"
            },
            "block-3": {
                "message-1": "Uporabniški račun v oblaku za administracijo podatkov",
                "message-2": "Samodejno varnostno kopiranje podatkov v oblak",
                "message-3": "Nadgradnja z dodatnimi moduli – upravljanje zalog, recepti, lokalni prevozi, potni nalogi itd.",
                "message-4": "Spletni vpogled v kartične transakcije in ustvarjanje poročil"
            }
        }
    },
    "partners": {
        "header": "Partnerji",
        "explanation": {
            "line-1-1": "Zanašamo se na mrežo več kot",
            "line-1-2": ", da vam zagotovimo najkakovostnejšo storitev sprejemanja brezgotovinskih plačil.",
            "line-2": "Imate svojo bazo strank in se želite pridružiti platformi M2PAY? Kontaktirajte nas!"
        },
        "button": "Postanite partner"
    },
    "online-payments": {
        "header": "Spletna plačila",
        "list-1": {
            "item-1": "Pripravljene in standardne rešitve za spletna plačila",
            "item-2": "Plačilo prek povezave",
            "item-3": "Integracija z mnogimi ponudniki storitev spletnih trgovin",
            "item-4": "Virtualni terminal"
        },
        "phone-messages": {
            "message-1": "Hitro in preprosto",
            "message-2": "Generiranje povezave za spletno plačilo",
            "message-3": "WooCommerce, Magento, PrestaShop, Shopify in drugi",
            "message-4": "Izvedite plačilo prek spleta neposredno prek spletnega vmesnika",
            "message-5": "Shranite podatke za ponavljajoča se plačila",
            "message-6": "Podpora za plačevanje prek naprav iOS",
            "message-7": "Podpora za plačevanje prek naprav Android",
            "message-8": "Nasveti in pomoč med in po integraciji"
        },
        "list-2": {
            "item-1": "Tokenizacija kartice",
            "item-2": "Apple Pay",
            "item-3": "Google Pay",
            "item-4": "IT podpora za spletne integracije z vašo spletno stranjo"
        }
    },
    "consultation": {
        "header": "Svetovanje in izobraževanje",
        "introduction": "Olajšujemo poslovanje",
        "explanation-1": {
            "line-1": "Povezujemo naše mobilne POS naprave z vašimi fiskalnimi blagajnami, prodajnim in drugim poslovnim programjem, CRM, ERP itd.",
            "line-2": "S to integracijo omogočamo boljši vpogled v transakcije in analizo podatkov, da imate popoln nadzor nad poslovanjem.",
            "line-3": "Plačujte na transakcijo, brez stroškov integracije ali skritih provizij."
        },
        "list-1": {
            "item-1": "Začetno svetovanje",
            "item-2": "Analiza potreb in obstoječih rešitev",
            "item-3": "Oblikovanje rešitve in izračun prihrankov"
        },
        "list-2": {
            "item-1": "Podpora pri vsakodnevnem delu",
            "item-2": "Prilagojeno in poenostavljeno vodenje finančnih poročil",
            "item-3": "Izobraževanje uporabnikov"
        },
        "explanation-2": {
            "line-1": "M2pay brezgotovinska plačila za vse oblike poslovanja.",
            "line-2": "Omogočamo brezgotovinska plačila tako majhnim kot velikim trgovcem ter ponudnikom storitvenih dejavnosti, vključno s tistimi, ki trenutno nimajo možnosti ali stroškovne učinkovitosti za njihovo uporabo."
        }
    },
    "api": {
        "sub-header-part-1": "Naši ",
        "sub-header-part-2": "API vmesniki.",
        "content-1": {
            "paragraph": {
                "line-1": "Naš transakcijski sistem temelji na API-jih, prilagojenih različnim platformam.",
                "line-2-1": "Omogočamo hitro in preprosto",
                "line-2-2": "integracijo z vašim obstoječim programjem, poleg tega imajo naše stranke možnost integracije z",
                "line-2-3": "za nadzor in podroben vpogled v podatke o transakcijah, potrebnih za analitiko."
            },
            "icon-infos": {
                "info-1": "Rest API",
                "info-2": "Billing API"
            }
        },
        "content-2": {
            "paragraph": {
                "line-1-1": "Našim strankam ponujamo že pripravljeno rešitev z",
                "line-1-2": "za plačevanje z virtualnimi sredstvi prek naših POS naprav in spletno, kar zagotavlja hitro in varno obdelavo transakcij v digitalnih valutah ter možnost integracije s programjem, razvitim pri tretjih osebah",
                "line-2-1": "Za eCommerce poslovanje nudimo rešitve z",
                "line-2-2": "za spletno obračunavanje s preprosto integracijo v vaših mobilnih aplikacijah in priljubljenih platformah, kot so WooCommerce, Magento, PrestaShop, Shopify in druge, ter jih prilagajamo potrebam vaše spletne trgovine."
            },
            "icon-infos": {
                "info-1": "Crypto API",
                "info-2": "E-com API"
            }
        }
    },
    "footer": {
        "funding": {
            "header": "Sredstva ESIF",
            "info": "Končni prejemnik finančnega instrumenta, sofinanciranega iz Evropskega sklada za regionalni razvoj v okviru Operativnega programa 'Konkurenčnost in kohezija'."
        },
        "company-info": {
            "base-capital": "Osnovni kapital: 126.160,00 EUR v celoti vplačan.",
            "bank": "Transakcijski račun pri Partner banki:",
            "hanfa-1": "Družba je vpisana pri",
            "hanfa-2": "kot ponudnik storitev virtualnih sredstev pod zaporedno številko 14.",
            "register-1": "M obrada je pod številko IPP420 vpisana v ",
            "register-link": "Register ponudnikov plačilnih storitev",
            "register-2": " ki ga vodi Hrvatska narodna banka za opravljanje plačilnih storitev sprejemanja plačilnih transakcij."
        },
        "contacts": {
            "header": "Kontaktirajte nas"
        },
        "links": {
            "header": "Koristne povezave",
            "links": {
                "conditions": "Splošni pogoji poslovanja M2PAY",
                "menu": "Cenik M2PAY",
                "instructions": "NAVODILA ZA UPORABO POS NAPRAV",
                "privacy-policy": "Pravilnik o zasebnosti"
            }
        }
    }
}